import { useMutation } from '@tanstack/react-query';
import Api from 'hooks/Api';
import { toastSuccess } from 'ui/partials/Toast';
import { useProfile } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';
import { ApiError, MFA } from 'utils/types';
import { LOGIN_FORM } from 'pages/public/forms/schema';

export interface LoginData extends MFA {
  role: string;
  _token: string;
  loginValidated: boolean;
  passwordExpired: boolean;
}
interface RESULT {
  data: LoginData;
}

export default function useLogin() {
  const { state } = useProvider();
  const { setProfile } = useProfile();

  return useMutation<RESULT, ApiError, LOGIN_FORM, any>({
    mutationFn: async (payload) => {
      const api = new Api(state);

      const data = await api.post({
        url: 'api/v1/auth/accounts/login',
        payload,
      });

      return data;
    },
    onSuccess: (successData, { remember }) => {
      const { loginValidated, passwordExpired } = successData?.data ?? {};

      setProfile({ profile: successData.data, remember });

      if (loginValidated) {
        window.location.href = '/';
      } else {
        if (passwordExpired)
          return toastSuccess('90-days old password expired.');

        toastSuccess('Verify your account via 2FA');
      }
    },
  });
}
